import { useState } from 'react';

import useStateFromQueryString from './useStateFromQueryString';

const useAppState = (initialState) => {
  const [appState, setState] = useState(initialState);
  const setAppState = (nextState) => {
    setState((prevState) => ({ ...prevState, ...nextState }));
  };
  useStateFromQueryString(setAppState);
  return [appState, setAppState];
};

export default useAppState;
